module.exports = __webpack_public_path__ + "static/media/dmitry_k.1f5ec5e5.jpg";